var tabs = (function($) {
	'use strict';

	var _triggerTabs = function() {

		$('[data-tab-target]').on('click', function() {
			var thisTab = $(this).data('tab-target'),
				currentTabs = $(this).closest('.tabs');

			$(currentTabs).find('.tabs__item').removeClass('active');
			$(currentTabs).find('.tabs__tab').removeClass('active');
			$(this).addClass('active');

			$(currentTabs).find('[data-tab-content="'+thisTab+'"]').addClass('active');
		});

	};

	function init() {
		_triggerTabs();
	}

	return {
		init:init
	};
}(jQuery));

jQuery(document).ready(function($) {
	tabs.init();
});
